var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-edital-layout"},[_c('EditalNavbar'),_c('main',{staticClass:"public-edital-layout__main"},[_c('div',{staticClass:"public-edital-layout__content"},[_vm._t("default")],2)]),_c('EditalFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }